/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  appBar: {
    position: 'relative',
  },
  title: {
    flex: 1,
  },
  text: {
    width: '400px',
    height: '69px',
    fontWeight: 'bold',
  },
}));
